// extracted by mini-css-extract-plugin
export default {"periodTab":"styles_periodTab__r2F17","periodTab__selected":"styles_periodTab__selected__58hUS","periodTab__mobile":"styles_periodTab__mobile__ok4ON"};